<h3 class="mb-0">{{ 'measurement.rawDataViewer.title' | translate }}</h3>
<p class="mb-3 text-surface-500 dark:text-surface-400">{{ measurement().name }}</p>

<p-divider></p-divider>

<div class="flex flex-wrap gap-2 mb-4">
  <p-button
    [label]="'measurement.rawDataViewer.downloadSelected' | translate"
    icon="fa-solid fa-download"
    severity="secondary"
    [outlined]="true"
    [disabled]="!selected().length || downloading()"
    (onClick)="downloadSelected()"
  />
  <p-button
    [label]="'measurement.rawDataViewer.downloadAll' | translate"
    icon="fa-solid fa-file-zipper"
    [loading]="downloading()"
    [disabled]="!rows().length"
    (onClick)="downloadAll()"
  />
</div>

@if (loading()) {
  <div class="flex flex-col gap-3">
    <p-skeleton height="2.5rem" borderRadius="0.5rem" />
    <p-skeleton height="10rem" borderRadius="0.5rem" />
  </div>
} @else if (!rows().length) {
  <p-message severity="info" styleClass="w-full">
    {{ 'measurement.rawDataViewer.empty' | translate }}
  </p-message>
} @else {
  <p-table
    [value]="rows()"
    dataKey="_id"
    [selection]="selected()"
    (selectionChange)="selected.set($event)"
    [rowHover]="true"
    [scrollable]="false"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem"><p-tableHeaderCheckbox /></th>
        <th>{{ 'measurement.rawDataViewer.file' | translate }}</th>
        <th>{{ 'measurement.rawDataViewer.channel' | translate }}</th>
        <th>{{ 'measurement.rawDataViewer.ingestedAt' | translate }}</th>
        <th>{{ 'measurement.rawDataViewer.status.label' | translate }}</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td><p-tableCheckbox [value]="row" /></td>
        <td class="max-w-[16rem]">
          <span class="block truncate" [pTooltip]="row.filename">{{ row.filename }}</span>
        </td>
        <td class="tabular-nums">{{ row.channelId }}</td>
        <td class="tabular-nums">{{ row.createdAt | date:'dd/MM/yyyy HH:mm:ss' }}</td>
        <td>
          <div class="flex items-center gap-1 flex-wrap">
            <p-tag
              [severity]="tagSeverity(row.status)"
              [value]="('measurement.rawDataViewer.status.' + row.status) | translate"
            />
            @if (!row.linked) {
              <p-tag severity="warn" [value]="'measurement.rawDataViewer.status.unlinked' | translate" />
            }
            @if (row.error) {
              <i class="fa-solid fa-circle-exclamation text-red-500" [pTooltip]="row.error"></i>
            }
          </div>
        </td>
        <td class="text-right">
          <p-button
            icon="fa-solid fa-download"
            severity="secondary"
            [text]="true"
            [loading]="isDownloadingRow(row)"
            (onClick)="downloadOne(row)"
            [pTooltip]="'button.download' | translate"
            tooltipPosition="top"
          />
        </td>
      </tr>
    </ng-template>
  </p-table>
}
